<template>
    <div>
        <template v-if="price">
            {{ price.name }} : <strong>{{ price.formatted_amount }}</strong>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            registrant: Object,
            course: Object,
        },
        computed: {
            price() {
                return this.course.prices?.find(price => price.id === this.registrant.course_price_id);
            },
        }
    }
</script>
